export enum RegionLocationGridType {
  Temperature = 'Temperature',
  FlTemperature = 'FlTemperature',
  MaxDewpoint = 'MaxDewpoint',
  RH = 'RH',
  AvgTemperature = 'AvgTemperature',
  FeelsLike = 'FeelsLike',
  DateHeader = 'DateHeader',
  Precipitation = 'Precipitation',
  Pop = 'POP',
  Wind = 'Wind',
  WindGust = 'WindGust',
  WindDirection = 'WindDirection',
  Irradiance = 'Irradiance',
  PercOfClearSkyIrrad = 'PercOfClearSkyIrrad',
  CloudCover = 'CloudCover',
}
